/**
 * Shared date validation constants and error messages
 * Used across content-search and internal-audit domains
 */

/**
 * Maximum allowed date range in days
 */
export const MAX_DATE_RANGE_DAYS = 90;

/**
 * Standardized date validation error messages
 */
export const DATE_VALIDATION_ERRORS = {
  END_DATE_FUTURE: 'End date cannot be in the future',
  START_DATE_TOO_OLD: 'Start date cannot be older than 90 days',
  END_BEFORE_START: 'End date cannot be before start date',
} as const;
